<template>
    <div>
        <h3>Popup Sample</h3>
        <input ref="testID" placeholder="테스트input창">
        <b-button class="mt-3" block @click="alertTest">Alert</b-button>
        <b-button class="mt-3" block @click="confirmTest">Confirm</b-button>
        <!--<b-button class="mt-3" block @click="PopupTest">Popup!</b-button>-->
        <br/>
        <b-button class="mt-3" block @click="isShowAdminModalSurvey = true">survey</b-button>
        <AdminModalSurvey v-if="isShowAdminModalSurvey" @modal-closed="handleModalClosed"/>
        <b-button class="mt-3" block @click="isShowCustomerModalSurvey = true">survey(customer)</b-button>
        <CustomerModalSurvey v-if="isShowCustomerModalSurvey" v-bind:surveyIdx='1' @modal-closed="handleModalClosed"/>
    </div>
</template>

<script>
import { eventBus } from '@/main.js';
import AdminModalSurvey from '@/components/survey/admin/ModalSurvey'
import CustomerModalSurvey from '@/components/survey/customer/ModalSurvey'
// import ConfirmDialogue from '@/components/modal/ConfirmDialogue'
// import PopupModal from './KakaoLogin.vue'

export default {
  name: 'PopupSample',
  components:{
    AdminModalSurvey,
    CustomerModalSurvey
    //  PopupModal
  },
  data(){
    return{
      isShowAdminModalSurvey: false,
      isShowCustomerModalSurvey: false
    }
  },
  methods:{
    alertTest(){
      this.$alert('알림', '길이 조정해주세요.', "확인", {
        'before-open': (/*event*/) => {
          //event.cancel() // 팝업이 열리는 것을 차단
          console.log('before open!')
        },
        'opened': () => {
          console.log('opened!')
        },
        'before-close': (/*event*/) => {
          //event.cancel() // 팝업이 닫히는 것을 차단
          console.log('before close!')
        },
        'closed': () => {
          console.log('closed!')
          this.$refs.testID.focus() // 포커스 이동 샘플
        }
      })
    },
    confirmTest(){
      var response = this.$createConfirmResponse()

      this.$confirm("title", "contents", "확인", "취소", response, {
        'before-open': (/*event*/) => {
          //event.cancel() // 팝업이 열리는 것을 차단
          console.log('before open!')
        },
        'opened': () => {
          console.log('opened!')
        },
        'before-close': (/*event*/) => {
          //event.cancel() // 팝업이 닫히는 것을 차단
          console.log('before close!')
        },
        'closed': () => {
          console.log('closed!')
          console.log('confirm result: ' + response.result)
        }
      })
    },
    handleModalClosed(value){
      switch(value){  
        case AdminModalSurvey.name:
          this.isShowAdminModalSurvey = false
          break
        case CustomerModalSurvey.name:
          this.isShowCustomerModalSurvey = false
          break
      }
    },
    focusInput(){
      this.$nextTick(() => {
        let focusItem = this.$store.state.modal.focusItem;
        this.$refs[focusItem].focus()
      })
    },
    PopupTest() {
      //modal 창 닫기 <button @click="$emit('close')">Close</button>
      //<v-dialog /> 를 작성해야한다.
      // this.$modal.show(
      //   PopupModal,
      //   { 
      //     text: 'This text is passed as a property',
      //     buttons: [
      //     {
      //       title: 'Cancel',
      //       handler: () => {
      //         this.$modal.hide('dialog')
      //       }
      //     }]
      //   }, 
      //   { 
      //     draggable: false, //모달 창을 드래그할 수 있는 속성
      //     clickToClose: false, //배경 눌러도 창을 끌 수 없다.
      //     width: '500px',
      //     height: '700px',
      //   },
        
      // )
    }
  },
  mounted() {
      eventBus.$on('callFromModal', function() {
          console.log('callFromModal 호출');
      });

      eventBus.$on('callForFocus', this.focusInput);
  }

}
</script>